import ClipboardJS from 'clipboard';

export default function (context = document) {
  if (context.querySelector('.js-copy-to-clipboard')) {
    const clipboard = new ClipboardJS('.js-copy-to-clipboard');
    clipboard.on('success', (e) => {
      window.alert("Link copied to clipboard");
      e.clearSelection();
    })
  }
}
